import {
  GET_ACTION_HISTORIES,
  GET_ACTION_HISTORIES_SUCCESS,
  GET_ACTION_HISTORIES_FAILED,
  EXPORT_ACTION_HISTORIES,
  EXPORT_ACTION_HISTORIES_SUCCESS,
  EXPORT_ACTION_HISTORIES_FAILED,
} from './actionTypes';

const initialState = {
  actionHistories: [],
  totalActionHistories: 0,
  isLoadingGetActionHistories: false,
  isLoadingExportActionHistories: false,
};

export default function managerOperation(state = initialState, action) {
  switch (action.type) {
    case GET_ACTION_HISTORIES:
      return {
        ...state,
        isLoadingGetActionHistories: true,
      };

    case GET_ACTION_HISTORIES_SUCCESS: {
      const data = action.payload?.data || [];
      const total = action.payload?.total ?? data.length;

      return {
        ...state,
        isLoadingGetActionHistories: false,
        actionHistories: data,
        totalActionHistories: total,
      };
    }

    case GET_ACTION_HISTORIES_FAILED:
      return {
        ...state,
        isLoadingGetActionHistories: false,
      };

    case EXPORT_ACTION_HISTORIES:
      return {
        ...state,
        isLoadingExportActionHistories: true,
      };

    case EXPORT_ACTION_HISTORIES_SUCCESS:
    case EXPORT_ACTION_HISTORIES_FAILED:
      return {
        ...state,
        isLoadingExportActionHistories: false,
      };

    default:
      return state;
  }
}
